// src/components/ActionsMenuGrid.js
import React from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import PropTypes from "prop-types";

export default function ActionsMenuGrid({
  row,
  isUploaded,
  onDownloadList,
  onUploadCSV,
  onDownloadMarks,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {/* 1️⃣ Download Template */}
        <MenuItem
          onClick={() => {
            onDownloadList(row);
            handleClose();
          }}
          sx={{
            py: 0.5, // reduce vertical padding
            minHeight: 32, // default is ~48
            fontSize: "0.9rem",
            color: "green",
            "&:hover": { backgroundColor: "rgba(0,128,0,0.1)" },
          }}
        >
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Post Marks & Students List"
            primaryTypographyProps={{
              fontSize: "0.9rem",
            }}
          />
        </MenuItem>

        {/* 2️⃣ Upload CSV */}
        <MenuItem
          component="label"
          sx={{
            py: 0.5, // reduce vertical padding
            minHeight: 32, // default is ~48
            fontSize: "0.9rem",
            color: "green",
            "&:hover": { backgroundColor: "rgba(0,128,0,0.1)" },
          }}
        >
          <ListItemIcon>
            <UploadFileIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Upload Internal marks CSV"
            primaryTypographyProps={{
              fontSize: "0.9rem",
            }}
          />
          <input
            type="file"
            hidden
            accept=".csv"
            onChange={(e) => {
              onUploadCSV(e, row);
              handleClose();
            }}
          />
        </MenuItem>

        {/* 3️⃣ Download Marks */}
        <MenuItem
          disabled={!isUploaded}
          onClick={() => {
            onDownloadMarks(row);
            handleClose();
          }}
          sx={{
            py: 0.5, // reduce vertical padding
            minHeight: 32, // default is ~48
            fontSize: "0.9rem",
            color: "green",
            "&:hover": { backgroundColor: "rgba(0,128,0,0.1)" },
          }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <DownloadIcon sx={{ fontSize: 18 }} />
          </ListItemIcon>
          <ListItemText
            primary="Download Internal Marks"
            primaryTypographyProps={{
              fontSize: "0.9rem",
            }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}

ActionsMenuGrid.propTypes = {
  row: PropTypes.object.isRequired,
  isUploaded: PropTypes.bool.isRequired,
  onDownloadList: PropTypes.func.isRequired,
  onUploadCSV: PropTypes.func.isRequired,
  onDownloadMarks: PropTypes.func.isRequired,
};
